import "./MarketingIdentity.css";
import "./MarketingIdentityResponsive.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomAnchor from "../../../shared/Anchor/CustomAnchor";
import { faStore } from "@fortawesome/free-solid-svg-icons";

function MarketingIdentity() {
  return (
    <div className="marketing-identity">
      <div className="marketing-identity-overlay"></div>
      <div className="d-block">
        <h1>Eat Better, Live Healthier</h1>
        <div className="marketing-id-underline"></div>
      </div>
      <div className="d-block">
        <p>
          Join the movement toward healthier living with our farm-fresh
          vegetables and herbs. Whether you're managing a lifestyle condition,
          feeding your family, or simply making more mindful choices, we've got
          you covered with convenient, eco-friendly, and nutritious options.
        </p>
      </div>
      <div className="d-block market-shop-btn-container">
        <CustomAnchor path="/shop" classname="btn btn-light marketing-shop-btn">
          <span>SHOP NOW</span>
          <FontAwesomeIcon icon={faStore} />
        </CustomAnchor>
      </div>
    </div>
  );
}

export default MarketingIdentity;
